import { Bound } from "lib/@components/binding/Bound"
import { Sortable } from "lib/@components/Sortable"
import { Box, List } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { TaskOrHeader } from "routes/schedule/tasks/taskOrHeader"
import { ListItemBox } from "lib/@components/ListItemBox"
import { TaskListRefresh } from "event-definitions"
import { arrayMoveInPlace } from "lib/ArrayMoveInPlace"
import { indexAuthoringTasksInSchedule } from "authoring/routes/project/schedule-editor/lib/index-authoring-tasks-in-schedule"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { AuthoringAddTaskButton } from "./authoring-task-actions"

export function AuthoringTaskListDisplay({ tasks, schedule }) {
    const { editMode, refresh } = useBoundContext()
    const scheduleTasks = tasks ?? []

    return (
        (!!scheduleTasks.length || editMode) && (
            <>
                <Sortable onDragEnd={orderItems} items={scheduleTasks} id="$sort">
                    <List dense>
                        <Repeat list={scheduleTasks} item={<TaskOrHeader />} keyFn={(v) => v.id} />
                    </List>
                </Sortable>
                <Bound schedule={schedule}>
                    <ListItemBox>
                        <AuthoringAddTaskButton />
                        <Box flex={1} />
                    </ListItemBox>
                </Bound>
            </>
        )
    )

    function orderItems({ active, over }) {
        if (!over) return false
        const draggedItem = scheduleTasks.findIndex((t) => active.id === `sort_${t.$sort}`)
        const overItem = scheduleTasks.findIndex((t) => over.id === `sort_${t.$sort}`)

        if (overItem < 0 || draggedItem < 0) {
            console.log("No match")
            return false
        }
        arrayMoveInPlace(scheduleTasks, draggedItem, overItem)
        schedule.tasks = scheduleTasks
        indexAuthoringTasksInSchedule(schedule)
        TaskListRefresh.raise()
        refresh()
        return false
    }
}
